import { useMsal } from '@azure/msal-react';
import { useAuth } from '../../../../hooks/auth';
import { useTranslation } from '../../../../hooks/i18n';
import { getNameForAvatarInitials } from '../../../../utils/user';

export const useSidebarUser = () => {
  const { userProfile, userPhoto, account } = useAuth();
  const { accounts, instance } = useMsal();
  const { t } = useTranslation();

  const msalAccount = account ?? instance.getActiveAccount() ?? accounts[0];
  const fullName =
    userProfile?.name ??
    userProfile?.email ??
    userProfile?.userPrincipalName ??
    msalAccount?.name ??
    msalAccount?.username ??
    '';

  const displayName = getNameForAvatarInitials(fullName) || t('dashboardLayout.user');

  return { displayName, userPhoto };
};
